<template>
  <div>
    <div class="wrapper_item">
      <label for="email" class="wrapper_label">Email</label>
      <input name="email" autocomplete="off" v-model="email" id="email" v-validate="'required|email'" data-vv-validate-on="blur" class="wrapper_input" type="text" @keyup.enter="login">
      <span class="text-danger text-sm">{{ errors.first('email') }}</span>
    </div>
    <div class="wrapper_item">
      <app-password v-model="password" ref="password" v-validate="'required'" data-vv-validate-on="blur" @enter="login"/>
      <span class="text-danger text-sm">{{ errors.first('password') }}</span>
    </div>
    <button class="wrapper_button" @click="login()">Войти</button>
  </div>
</template>

<script>
import AppPassword from "@/components/app-password";

export default {
    name: "login",
    data() {
        return {
            email: '',
            password: ''
        }
    },
    components: { AppPassword },
    methods: {
        login() {
            this.$validator.validateAll().then(success => {
                if (success) {
                  this.$store.commit('setAuthLoading', true)
                    this.$http.post( '/login',{
                        password: this.password,
                        email: this.email
                    })
                        .then(({data}) => {
                          if (data.redirect) {
                            location.href = data.redirect;
                          }
                          if (data.error) {
                            this.$toast.error('Неправильный логин либо пароль...');
                          }
                          if (data.no_active) {
                            this.$toast.error('Администратор еще не активировал ваш профиль');
                          }
                          if (data.user.token) {
                              localStorage.setItem('token', data.user.token)
                              localStorage.setItem('type', data.user.type)
                              /*this.$router.push({name: 'main'})*/
                              location.href = data.user.type == 1 ? '/provider-orders' : '/purchaser-orders' //для получения актуальной версии сайта
                          }
                      })
                      .catch(()=>{
                          // this.$toast.error('Неверный логин или пароль!');
                      })
                      .finally(() => this.$store.commit('setAuthLoading', false))
                }
            })

        }
    }
}
</script>
